import BaseService from './BaseService';
import apiClient from '../plugins/axios';

/**
 * Voice Service
 */
class VoiceService extends BaseService {
  constructor() {
    super('voice');
  }

  /**
   * Tüm sesleri listele
   * @returns {Promise}
   */
  async getAllVoices() {
    try {
      const response = await apiClient.get('/voice');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Yeni ses dosyası yükle ve oluştur
   * @param {FormData} formData - Form verileri (name, description, file)
   * @returns {Promise}
   */
  async createVoice(formData) {
    try {
      const response = await apiClient.post('/voice', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Ses dosyasını çalmak için binary stream (blob) getirir.
   * Sadece custom (yüklenen) seslerde Asset olduğu için başarılı döner; built-in'de 404 olur.
   * @param {string} id - Ses ID'si
   * @returns {Promise<Blob>}
   */
  async getVoicePlayBlob(id) {
    const response = await apiClient.get(`/voice/${id}/play`, { responseType: 'blob' });
    return response.data;
  }

  /**
   * Ses dosyasını sil
   * @param {string} id - Ses ID'si
   * @returns {Promise}
   */
  async deleteVoice(id) {
    try {
      const response = await apiClient.delete(`/voice/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Ses dosyası yükleme için FormData oluşturma helper'ı
   * @param {Object} voiceData - Ses verileri
   * @param {File} file - Ses dosyası
   * @returns {FormData}
   */
  createVoiceFormData(voiceData, file) {
    const formData = new FormData();

    if (voiceData.name) {
      formData.append('name', voiceData.name);
    }

    if (voiceData.description) {
      formData.append('description', voiceData.description);
    }

    if (file) {
      formData.append('file', file);
    }

    return formData;
  }
}

export default new VoiceService();
